import { db } from '../firebase';
import { collection, getDocs, getDoc, doc, query, orderBy } from 'firebase/firestore';

export const getBanners = async () => {
  const q = query(collection(db, 'home_banners'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data());
};

export const getIntro = async () => {
  const snap = await getDoc(doc(db, 'home_intro', 'content'));
  return snap.exists() ? snap.data() : { heading: '', paragraph: '' };
};

export const getWhyChoose = async () => {
  const snap = await getDoc(doc(db, 'home_why_choose', 'content'));
  return snap.exists() ? snap.data() : { image: '', points: [] };
};

export const getInfoCards = async () => {
  const q = query(collection(db, 'home_info_cards'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data());
};

export const getVanityImages = async () => {
  const q = query(collection(db, 'home_vanity_images'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data().url);
};
